import { render, staticRenderFns } from "./TransactionRecordDetail.vue?vue&type=template&id=5cadf54b&scoped=true&"
import script from "./TransactionRecordDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRecordDetail.vue?vue&type=style&index=0&id=5cadf54b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cadf54b",
  null
  
)

export default component.exports